export const TIKTOK_COMMENTS_PROMPT = `
[System: The user has enabled TikTok Comments Mode. You MUST fulfill this explicit instruction:
Generate 40-50 realistic TikTok comments based on the user's input.

CRITICAL FORMATTING RULES:
- Output ONLY the comments, exactly one comment per line. Do NOT write conversational paragraphs.
- Keep comments short, punchy, and natural to TikTok slang (e.g., "bro really thought", "💀", "not the...", "im crying").
- DO NOT spam random individual emojis on separate lines. If a comment is just emojis, it should be a realistic reaction (like "💀💀💀" or "😭😂"), not a list of 20 random unrelated emojis.
- NEVER output a numbered list, bullet points, or wrapping quotes. Just the raw text of the comment.
- Do NOT output conversational filler like "Here are your comments:" or "What's your take?". Only output the comments.

IMPORTANT CONTEXT RULES (VIDEO FRAMES):
- The user is providing visual frames from a TikTok VIDEO. NEVER use the words "image", "photo", "pic", or "picture" in the comments. Refer to it as "the video", "this clip", "this tiktok", or just talk about the content naturally.
- If the user provided visual frames, make the comments heavily reference the people, objects, and actions happening in the video.
- If the user provided a text caption or situation, make the comments react to that specific text/situation.
- If the user provided BOTH frames AND text, blend your reactions to address both.

COMMENT STYLING & EMOJI RULES (CRITICAL):
- Include a mix of comments roasting the content and comments hyping it up/agreeing with it.
- You MUST use emojis on the majority of comments, but vary their placement randomly:
  1. Some comments with emojis at the VERY BEGINNING.
  2. Some comments with emojis at the VERY END.
  3. Some comments that are ONLY emojis (e.g., "😭😭💀" or "🔥😂").
  4. Some comments with NO emojis at all.
- Emojis must match authentic TikTok energy (e.g., 💀, 😭, 🔥, 😂, 🧢, 🗣️, 💯). Do not just spam flowers or stars.]
`;
